<template>
  <div class="sell">
    <van-search
      v-model="keyword"
      show-action
      label=""
      placeholder="请输入姓名或手机号"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>

    <div class="withdraw-tab">
      <van-tabs v-model="active" @change="onClick">
        <van-tab :title="parent_title">
          <div class="sell-main">
            <ul>
              <van-pull-refresh v-model="refreshing" @refresh="onLoad">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <li v-for="(item, index) in list" :key="index">
              <span class="img">
                <van-image
                  round
                  width="2.5rem"
                  height="2.5rem"
                  :src="item.avatar"
                />
              </span>
                    <div class="sell-li-r">
                      <div class="r-n-t">
                        <span class="nickname">{{ item.nickname }}</span>
                        <span class="title">{{ item.name }}  {{ item.phone }}</span>
                      </div>
                      <span class="grade">{{ item.balance }}</span>
                      <span class="recharge"><van-button type="primary" size="mini" @click="addEdit(item)">充值</van-button></span>
                    </div>
                  </li>
                </van-list>
              </van-pull-refresh>
            </ul>
          </div>
        </van-tab>
        <van-tab :title="parent_two_title"></van-tab>

      </van-tabs>
    </div>

    <van-dialog v-model="show" title="会员充值" show-cancel-button :before-close="beforeClose">
      <van-field
        v-model="info.nickname"
        name="昵称"
        label="昵称"
        readonly
      />
      <van-field
        v-model="info.name"
        name="姓名"
        label="姓名"
        readonly
      />
      <van-field
        v-model="info.phone"
        type="tel"
        label="手机号"
        readonly
      />
      <van-field
        v-model="info.price"
        name="金额"
        label="充值金额"
        placeholder="请输入充值金额"
        type="number"
        :rules="[{ required: true, message: '请输入充值金额' }]"
      />
    </van-dialog>

    <Floating toUrl="/users/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Search, Tab, Tabs, Empty, Image as VanImage, List, PullRefresh, Button, Form, Dialog, RadioGroup, Radio, Cell, CellGroup, Picker, Popup } from 'vant'

  export default {
    components: {
      [Search.name]: Search,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Empty.name]: Empty,
      [VanImage.name]: VanImage,
      [List.name]: List,
      [Button.name]: Button,
      [PullRefresh.name]: PullRefresh,
      [Picker.name]: Picker,
      [Popup.name]: Popup,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Dialog.Component.name]: Dialog.Component,
      Form
    },
    name: 'sell',
    data () {
      return {
        keyword: '',
        active: 0,
        page: 1,
        list: [],
        parent_title: '会员列表',
        parent_two_title: '充值记录',
        loading: false,
        finished: false,
        refreshing: false,
        show: false,
        showPicker: false,
        info: {
          id: 0,
          phone: '',
          name: '',
          nickname: '',
          price: '',
        }
      }
    },
    created () {
      //
    },
    methods: {
      onConfirm(value) {
        this.info.bank_name = value;
        this.showPicker = false;
      },
      addEdit(record) {
        this.info.id = record.id
        this.info.name = record.name
        this.info.nickname = record.nickname
        this.info.phone = record.phone
        this.info.price = ''
        this.show = true
      },
      beforeClose : function (action, done) { // 点击事件 - 备注按钮提示框
        if (action === 'confirm') { // 确认
          if(this.info.price == ''){
            this.$toast('请输入充值金额')
            done(false);
            return
          }
          if(this.info.id != 0){
            // 添加
            this.$api.post('manage/recharge', this.info, r=>{
              if(r.success === 1){
                this.$toast('充值成功')
                this.onSearch()
              }
            })
          }
          done();
        } else if (action === 'cancel') { // 取消
          this.info.id = 0
          this.info.name = ''
          this.info.phone = ''
          this.info.nickname = ''
          this.info.price = ''
          done();
        }
      },
      onLoad () {
        this.$api.get('manage/member', {page: this.page, search:this.keyword}, r => {
          let data = r.data.data
          this.list.push.apply(this.list, data)
          this.loading = false
          if (this.page >= r.data.data.last_page) {
            this.finished = true;
          }
          this.page = this.page + 1
        })
      },
      onRefresh () {
        this.page = this.page + 1
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },
      onSearch() {
        this.list = []
        this.page = 1
        this.onLoad()
      },
      onClick(name, title) {
        if(name == 1){
          //this.$router.push({name: 'sellOrders'})
          window.location.href = "/manage/rechargeRecord"
        }
      }
    }
  }
</script>

<style scoped>
  .sell{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  .sell-main{
    overflow: hidden;
    padding:10px 0;
  }
  .sell-main ul{
    padding:10px 15px;
  }
  .sell-main ul li{
    font-size: 13px;
    overflow: hidden;
    margin-bottom: 10px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }
  .sell-main ul li .img{
    float: left;
    width: 15%;
  }
  .sell-main ul li .sell-li-r{
    float: right;
    width: 85%;
  }
  .sell-main ul li .sell-li-r span{
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sell-main ul li .sell-li-r .r-n-t{
    float: left;
    width: 45%;
    overflow: hidden;
  }
  .sell-main ul li .sell-li-r .r-n-t span{
    display: block;
  }
  .sell-main ul li .sell-li-r .grade{
    width: 25%;
    text-align: right;
    line-height: 2.5rem;
    overflow: hidden;
    height: 2.5rem;
  }
  .sell-main ul li .sell-li-r .recharge{
    width: 25%;
    float: right;
    text-align: right;
    line-height: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/recharge.vue